module.exports = __webpack_public_path__ + "img/42.5.COD.50c5cc32.png";